@import '../../../global/variables.scss';

/**
 * Exposed CSS variables
 *
 * @prop --docked-utility-body-max-width: The maximum width of the body default is `25rem`
 * @prop --docked-utility-body-width: The width of the body default is `100vw`
 * @prop --docked-utility-body-border-color: The color of the border of the body default is `#c1c4d6`
 * @prop --docked-utility-body-padding: The padding of the body default is `1rem`
 * @prop --docked-utility-body-bg-color: The background color of the body default is `#fff`
 * @prop --docked-utility-header-border-bottom: The color of the border at the bottom of the header default is `#eb9c7f`
 * @prop --docked-utility-header-border-bottom-width: The width of the border at the bottom of the header default is `0.125rem`
 */

:host {
  display: none;
  font-family: $base-font-family;
}

:host(.open) {
  display: block;
}

div {
  display: block;
  position: absolute;
  bottom: 4.5rem;
  min-width: var(--docked-utility-body-max-width, 25rem);
  max-width: var(--docked-utility-body-max-width, 100vw);
  width: var(--docked-utility-body-width, 100vw);
  border: 0.0625rem solid var(--docked-utility-body-border-color, $neutral-300);
  border-bottom: none;
  border-radius: 0.5rem 0.5rem 0 0;
  padding: var(--docked-utility-body-padding, $size-2);
  padding-top: 0;
  background: var(--docked-utility-body-bg-color, $light);

  header {
    @include center;
    justify-content: space-between;
    padding: var(--docked-utility-body-padding, $size-2) 0 var(--docked-utility-body-padding, $size-2) 0;
    border-bottom: 0.125rem solid $orange-300;
    border-bottom-color: var(--docked-utility-header-border-bottom, $orange-300);
    border-bottom-width: var(--docked-utility-header-border-bottom-width, 0.125rem);
    margin-bottom: 0.5rem;

    button {
      cursor: pointer;
      background: none;
      border: none;
      &:focus-visible {
        @include focus;
        border-radius: 0.125rem;
      }
    }
  }

  section {
    overflow: auto;
    overflow-x: hidden;
    max-height: calc(100vh - 4.5rem - 5 * var(--docked-utility-body-padding, $size-2));
  }
}
